export default {
  LIST_FETCHED: 'POLITICAL_FETCHED',
  LIST_LOAD: 'POLITICAL_LOAD',
  NEWS_LIST_FETCHED: 'POLITICAL_NEWS_FETCHED',
  NEWS_LIST_LOAD: 'POLITICAL_NEWS_LOAD',
  NEWS_LIST_SET: 'POLITICAL_NEWS_SET',
};
